export const targetGroupsByPhysicalConstants = {
  TARGET_GROUPS_BY_PHYSICAL_LOADING: "TARGET_GROUPS_BY_PHYSICAL_LOADING",
  TARGET_GROUPS_BY_PHYSICAL_SUCCESS: "TARGET_GROUPS_BY_PHYSICAL_SUCCESS",
  TARGET_GROUPS_BY_PHYSICAL_FAILURE: "TARGET_GROUPS_BY_PHYSICAL_FAILURE",
};

export const createTargetGroupsByPhysicalConstants = {
  CREATE_TARGET_GROUPS_BY_PHYSICAL_LOADING:
    "CREATE_TARGET_GROUPS_BY_PHYSICAL_LOADING",
  CREATE_TARGET_GROUPS_BY_PHYSICAL_SUCCESS:
    "CREATE_TARGET_GROUPS_BY_PHYSICAL_SUCCESS",
  CREATE_TARGET_GROUPS_BY_PHYSICAL_FAILURE:
    "CREATE_TARGET_GROUPS_BY_PHYSICAL_FAILURE",
};

export const editTargetGroupsByPhysicalConstants = {
  EDIT_TARGET_GROUPS_BY_PHYSICAL_LOADING:
    "EDIT_TARGET_GROUPS_BY_PHYSICAL_LOADING",
  EDIT_TARGET_GROUPS_BY_PHYSICAL_SUCCESS:
    "EDIT_TARGET_GROUPS_BY_PHYSICAL_SUCCESS",
  EDIT_TARGET_GROUPS_BY_PHYSICAL_FAILURE:
    "EDIT_TARGET_GROUPS_BY_PHYSICAL_FAILURE",
};

export const deleteTargetGroupsByPhysicalConstants = {
  DELETE_TARGET_GROUPS_BY_PHYSICAL_LOADING:
    "DELETE_TARGET_GROUPS_BY_PHYSICAL_LOADING",
  DELETE_TARGET_GROUPS_BY_PHYSICAL_SUCCESS:
    "DELETE_TARGET_GROUPS_BY_PHYSICAL_SUCCESS",
  DELETE_TARGET_GROUPS_BY_PHYSICAL_FAILURE:
    "DELETE_TARGET_GROUPS_BY_PHYSICAL_FAILURE",
};
